// Validation for the five social media links (Instagram, Facebook, X, LinkedIn,
// YouTube) used by the Affiliate Link editor (index.js) and the Add Affiliate
// Link form (add_sharelink.js).
//
// Accepts http or https, an optional "www.", a trailing "/", and a query string
// or #fragment. An empty value and a bare site URL (e.g. "https://www.facebook.com/")
// are valid because the link is optional.

const SCHEME_AND_WWW = "https?:\\/\\/(?:www\\.)?";
// One path segment: anything except "/", "?", "#" and whitespace.
const SEG = "[^\\s/?#]+";
const TAIL = "\\/?(?:[?#]\\S*)?$";

const PATTERNS = {
  // /in/, /company/, /school/, /showcase/ and the legacy /pub/name/1/2/3 form
  linkedin: new RegExp(
    `^${SCHEME_AND_WWW}linkedin\\.com(?:\\/(?:in|company|school|showcase)\\/${SEG}|\\/pub\\/${SEG}(?:\\/${SEG})*)?${TAIL}`,
    "i"
  ),
  // handles can contain letters, digits, "." and "_"
  instagram: new RegExp(
    `^${SCHEME_AND_WWW}instagram\\.com(?:\\/[\\w.]+)?${TAIL}`,
    "i"
  ),
  // facebook.com and fb.com, including profile.php?id=123
  facebook: new RegExp(
    `^${SCHEME_AND_WWW}(?:facebook|fb)\\.com(?:\\/profile\\.php\\?id=\\d+|\\/(?!profile\\.php(?:[/?#]|$))${SEG}(?:\\/${SEG})*)?${TAIL}`,
    "i"
  ),
  // x.com and twitter.com
  twitter: new RegExp(
    `^${SCHEME_AND_WWW}(?:x|twitter)\\.com(?:\\/\\w+)?${TAIL}`,
    "i"
  ),
  // @handle, /channel/, /c/, /user/, legacy custom URL (/<name>), watch?v=,
  // playlist?list= and youtu.be/<id>
  youtube: new RegExp(
    `^${SCHEME_AND_WWW}(?:youtube\\.com(?:` +
      `\\/@[\\w.-]+` +
      `|\\/(?:channel|c|user)\\/[\\w.-]+` +
      `|\\/watch\\?v=[\\w-]+` +
      `|\\/playlist\\?list=[\\w-]+` +
      // legacy custom URL such as youtube.com/samsung (not the reserved words above)
      `|\\/(?!(?:watch|playlist|channel|c|user)(?:[/?#]|$))[\\w.-]+` +
      `)?|youtu\\.be\\/[\\w-]+)` +
      // after a watch / playlist / youtu.be id only extra query params may follow
      `(?:[&?#]\\S*)?\\/?$`,
    "i"
  ),
};

export const SOCIAL_ERROR_MESSAGES = {
  instagram: "Invalid Instagram link",
  facebook: "Invalid Facebook link",
  twitter: "Invalid X link",
  linkedin: "Invalid Linkedin link",
  youtube: "Invalid Youtube link",
};

// network: "instagram" | "facebook" | "twitter" | "linkedin" | "youtube"
export const isValidSocialUrl = (network, value) => {
  const trimmed = (value == null ? "" : String(value)).trim();
  if (trimmed === "") return true;
  const pattern = PATTERNS[network];
  return pattern ? pattern.test(trimmed) : false;
};
